import initAPI from '../../initAPI';
var apiName = 'util.tool.writeLog';
var pc = {
  vs: '1.7.0'
};
var platform = {
  pc: pc
};
function writeLog(params) {
  initAPI(apiName, {
    params: params,
    platform: platform
  });
}
export { writeLog };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/api/util/tool/log.js
// module id = null
// module chunks = 